import { configureStore, type ThunkAction, type Action } from '@reduxjs/toolkit';
import { rootReducer, type IRootState } from '@store/slices';

export const store = configureStore({
  reducer: rootReducer,
  // The two DEV-ONLY invariant checks (both are off in production builds)
  // walk the whole state after every dispatch. The scheduler slice carries
  // a site's entire plan plus its undo history — thousands of tasks — so the
  // walk was measured at ~400 ms per dispatch, and a drawer Save (three
  // dispatches) froze the UI for over a second before its network call even
  // started. Skip that one slice; every other slice stays checked.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: { ignoredPaths: ['scheduler'] },
      immutableCheck: { ignoredPaths: ['scheduler'] },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, IRootState, unknown, Action>;
